import { useContext } from 'react';

import { TimeseriesTooltipContext } from '../context/TimeseriesTooltip.context.js';
import { TimeseriesChartTooltipConfig } from '../types/timeseries-config.js';

export type TooltipConfig = TimeseriesChartTooltipConfig;

export const useTooltipConfig = (): TooltipConfig =>
  useContext(TimeseriesTooltipContext);
